(function () {
  /**
   * @ngdoc factory
   * @name coldCacheResponseInterceptor
   * @description Handles cold cache transformations, specifically for 401 and 202/503 CACHE_IS_COLD
   */
  angular.module('app.core.api.interceptor').provider('coldCacheResponseInterceptor', provider);

  function provider(_) {
    let whitelist = [];

    this.configure = configure;
    this.$get = $get;

    ///////////////

    /**
     * @description Configure the coldCacheResponseInterceptor
     * @param {Object} [config] - whitelist of api that require transform checks
     * @param {Array} [config.whitelist] - whitelist of api that require transform checks
     */
    function configure(config = {}) {
      whitelist = _.union(whitelist, config.whitelist);
    }

    /* @ngInject */
    function $get($injector, $log, $q, CACHE_IS_COLD, MAX_CACHE_IS_COLD_RETRIES) {
      return {response: responseHandler, responseError: responseErrorHandler};

      //////////////

      function responseHandler(response = {}) {
        // if one of the whitelisted APIs returns the default HTML, we know it should be a 403
        const errorCode = _.get(response, 'data.errorCode');
        if (
          isWhitelistedApi(response.config) &&
          response.status === 202 &&
          _.toUpper(errorCode) === CACHE_IS_COLD
        ) {
          return handleCacheIsCold(response);
        }
        return $q.resolve(response);
      }

      function responseErrorHandler(response = {}) {
        const errorCode = _.get(response, 'data.errorCode');
        if (
          isWhitelistedApi(response.config) &&
          response.status === 503 &&
          _.toUpper(errorCode) === CACHE_IS_COLD
        ) {
          return handleCacheIsCold(response);
        }
        return $q.reject(response);
      }

      /**
       * @description Helper to determine if api endpoint should be acted on
       * @param {Object} [config] - config of the api
       * @param {String} [config.url] - URL the request will be made to
       * @returns {Boolean} true if request url contains prefix of any whitelisted api
       */
      function isWhitelistedApi(config = {}) {
        return _.some(whitelist, (apiPrefix) => _.startsWith(config.url, apiPrefix));
      }

      /**
       * @description Helper to determine if api endpoint should be acted on
       * @param {Object} [response] - the response to process
       * @returns {Promise} a rejection if the retry limit has been reached, or a resolved promise
       */
      function handleCacheIsCold(response) {
        // Add the retries count on a custom rcData property
        if (!response.config.rcData) {
          response.config.rcData = {
            retries: 0,
          };
        } else if (response.config.rcData.retries >= MAX_CACHE_IS_COLD_RETRIES) {
          // Stop retrying after `MAX_CACHE_IS_COLD_RETRIES` retries.
          // Greater or equal (>=) then MAX_CACHE_IS_COLD_RETRIES because the increment is done below.
          $log.info('Cache is cold, retry limit reached.');
          return $q.reject(response);
        }

        // Increment retries
        response.config.rcData.retries += 1;

        $log.info(`Cache is cold, retrying. Attempt #${response.config.rcData.retries}`);

        // Using $injector to avoid circular dependency
        const $http = $injector.get('$http');
        // Retry XHR, we use $http as we don't know the original $resource used
        return $http(response.config);
      }
    }
  }
})();
